// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Db from "../../backend/Db.bs.jsx";
import * as React from "react";
import * as Assets from "../../assets/Assets.bs.jsx";
import * as Styles from "../../styles/components/Styles.bs.jsx";
import * as Stdlib_Null from "@rescript/runtime/lib/es6/Stdlib_Null.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as SectionWithHeader from "../../components/SectionWithHeader/SectionWithHeader.bs.jsx";
import * as JsxRuntime from "react/jsx-runtime";
import BeerListModuleCss from "./BeerList.module.css";

let classes = BeerListModuleCss;

function BeerList$PersonCell(props) {
  let onAddConsumption = props.onAddConsumption;
  let isUserAuthorized = props.isUserAuthorized;
  let formatConsumption = props.formatConsumption;
  let consumptions = props.consumptions;
  let rootNodeRef = React.useRef(null);
  let consumptionsStr = consumptions.map(c => formatConsumption(c.milliliters)).join("");
  let recentConsumptionTimestamp = Stdlib_Option.map(consumptions.at(-1), c => c.createdAt.getTime());
  let prevRecentConsumptionTimestampRef = React.useRef(recentConsumptionTimestamp);
  React.useEffect(() => {
    let prevRecentConsumptionTimestamp = prevRecentConsumptionTimestampRef.current;
    prevRecentConsumptionTimestampRef.current = recentConsumptionTimestamp;
    let listElement = rootNodeRef.current;
    if (!(listElement == null)) {
      let initialEffect = recentConsumptionTimestamp === prevRecentConsumptionTimestamp;
      if (!initialEffect) {
        let changedDueToExpiredConsumptions = recentConsumptionTimestamp === undefined && Stdlib_Option.mapOr(prevRecentConsumptionTimestamp, false, t => Date.now() - t > Db.slidingWindowInMillis);
        if (!changedDueToExpiredConsumptions) {
          listElement.animate({
            backgroundColor: "var(--surface-warning)"
          }, {
            duration: 500,
            iterations: 3,
            direction: "reverse"
          });
        }
      }
    }
  }, [recentConsumptionTimestamp]);
  return <div
    ref={Primitive_option.some(rootNodeRef)}
    className={classes.cellConsumption}
    role={"gridcell"}
  >
    <div>
      {props.personName}
    </div>
    {isUserAuthorized(50) || props.isCurrent && isUserAuthorized(20) ? <button
        className={Styles.utility.breakout}
        title={"Detail konzumace"}
        type={"button"}
        onClick={param => onAddConsumption()}
      /> : null}
    <div
      className={classes.consumption}
    >
      {consumptionsStr}
    </div>
  </div>;
}

let PersonCell = {
  make: BeerList$PersonCell
};

function BeerList(props) {
  let recentConsumptionsByUser = props.recentConsumptionsByUser;
  let personEntries = props.personEntries;
  let onTogglePersonVisibility = props.onTogglePersonVisibility;
  let onAddConsumption = props.onAddConsumption;
  let isUserAuthorized = props.isUserAuthorized;
  let formatConsumption = props.formatConsumption;
  let currentUserUid = props.currentUserUid;
  let match = React.useState(() => false);
  let setShowAll = match[1];
  let showAll = match[0];
  let personsToShow = React.useMemo(() => {
    if (showAll) {
      return personEntries;
    } else {
      return personEntries.filter(param => Db.isPersonActive(param[1]));
    }
  }, [
    personEntries,
    showAll
  ]);
  return <SectionWithHeader.make
    buttonsSlot={<>
      {React.cloneElement(<label
        className={classes.labelShowAll + ` ` + Styles.button.base + ` ` + Styles.button.iconOnly + ` ` + Styles.button.variantStealth}
      >
        {"👁️"}
        <span
          className={Styles.utility.srOnly}
        >
          {"Zobrazit všechny hosty"}
        </span>
        <input
          role={"switch"}
          checked={showAll}
          type={"checkbox"}
          onChange={e => {
            let target = e.target;
            let checked = target.checked;
            setShowAll(param => checked);
          }}
        />
      </label>, {
        "data-checked": showAll ? "true" : "false"
      })}
    </>}
    className={classes.root + ` ` + (
      showAll ? classes.showAll : ""
    )}
    headerId={"active_persons"}
    headerSlot={"Lístek"}
  >
    {!showAll && personsToShow.length === 0 ? <p
        className={SectionWithHeader.classes.emptyMessage + ` ` + classes.emptyMessage}
      >
        <span>
          {"Všichni jsou schovaní, koukni na ně přes očičko"}
        </span>
        <span>
          {"⤴"}
        </span>
      </p> : <div
        className={classes.gridBeer}
        role={"grid"}
      >
        {personsToShow.map(personEntry => {
          let person = personEntry[1];
          let personId = personEntry[0];
          let consumptions = Stdlib_Option.getOr(recentConsumptionsByUser.get(personId), []);
          let isCurrent = Stdlib_Null.mapOr(person.userId, false, userId => userId === currentUserUid);
          let personVisible = !showAll || Db.isPersonActive(person);
          return <div
            key={personId} 
            aria-current={isCurrent ? "true" : "false"}
            role={"row"}
          >
            <PersonCell.make
              key={personId} 
              consumptions={consumptions}
              formatConsumption={formatConsumption}
              isCurrent={isCurrent}
              isUserAuthorized={isUserAuthorized}
              onAddConsumption={() => onAddConsumption(personEntry)}
              personName={person.name}
            />
            <div
              className={classes.cellToggleVisibility}
              role={"gridcell"}
            >
              <label>
                <input
                  role={"switch"}
                  checked={personVisible}
                  type={"checkbox"}
                  onChange={param => onTogglePersonVisibility(personEntry)}
                />
                <img
                  src={personVisible ? Assets.eyeShow : Assets.eyeHidden}
                />
              </label>
            </div>
          </div>;
        })}
      </div>}
  </SectionWithHeader.make>;
}

let make = BeerList;

export {
  classes,
  PersonCell,
  make,
}
/* classes Not a pure module */
